// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { HistoryForLicenseModel } from "models/HistoryForLicense";
import { NotificationsType } from "models/NotificationsType";
import { RejectionReason } from "models/RejectionReason";
import { ReportInformationFirstStep } from "models/ReportInformationFirstStep";
import { ReportModel } from "models/ReportModel";
import { ReportStatus } from "models/ReportStatus";
import { ReportStatuses } from "models/ReportStatuses";
import { ReportViolation } from "models/ReportViolationType";
import { ReversedDecision } from "models/ReversedDecision";
import { TagModel } from "models/TagModel";
import { getApiSLice } from "utils/getApiBaseQuery";
import { DBEntityNameCodes } from "features/api/constants/enums";

export const reportsApiSliceDev = getApiSLice("dev").injectEndpoints({
  endpoints: (builder: unknown) => ({
    getStatuses: builder.query<ReportStatuses, string | number>({
      query: (selectedRole = 1) => ({
        url: `/utils/GetReportStatuses/?roleId=${selectedRole}`,
        method: "GET",
      }),
    }),
    getReportRejectionReason: builder.query<RejectionReason[], void>({
      query: () => ({
        url: "utils/GetReportRejectionReason",
        method: "GET",
      }),
    }),
    getReversedDecisions: builder.query<ReversedDecision[]>({
      query: ({ start, end, userId }) => ({
        url: "/utils/GetReversedDecisions",
        method: "GET",
        params: { start, end, userId },
      }),
      providesTags: ["ReversedDecisions"],
    }),
    getCompleted: builder.query<ReportStatus[], { userBoId?: string | number }>(
      {
        query: ({ start, end, userBoId }) => ({
          url: "/reports/getCompletedReport",
          method: "GET",
          params: {
            start,
            end,
            userBoId,
          },
        }),
        providesTags: ["CompletedReports"],
      }
    ),
    getReportsListDto: builder.query({
      query: ({
        role,
        isFollowUpStatuses,
        page,
        searchInput,
        body,
        isSearchRequest,
      }) => {
        return {
          url: "/reports/GetReportListDto",
          method: "POST",
          params: {
            role,
            isFollowUpStatuses,
            page,
            searchInput,
            isSearchRequest,
          },
          body,
        };
      },
      providesTags: ["ReportsList"],
    }),
    getReporterInformation: builder.query<ReporterInformationModel, void>({
      query: ({ reportID, role }) => ({
        url: "/utils/GetReporterInformationForBo",
        method: "GET",
        params: { reportID, role },
      }),
    }),
    getReportInformationFirstStep: builder.query<
      ReportInformationFirstStep,
      void
    >({
      query: ({ reportID, role, isInProgress }) => ({
        url: "/reports/GetReportDetails",
        method: "GET",
        params: { reportID, role, isInProgress },
      }),
      providesTags: ["reportDetailsFirstStep"],
    }),
    getTags: builder.query<TagModel, void>({
      query: () => ({
        url: "/tags/GetTagListForBo",
        method: "GET",
      }),
    }),
    getHistoryForLicense: builder.query<HistoryForLicenseModel, void>({
      query: ({ licenseNumber, reportId }) => ({
        url: "/utils/GetHistoryForLicenseNumber",
        method: "GET",
        params: { licenseNumber, reportId },
      }),
    }),
    getReportsViolationTypes: builder.query<ReportViolation[], void>({
      query: () => ({
        url: "/utils/GetPolicyAndOffenceTypes",
        method: "GET",
      }),
    }),
    getNotifications: builder.query<NotificationsType[]>({
      query: () => ({
        url: "backOffice/GetManagedUpdates",
        method: "GET",
      }),
    }),
    getSeriousOffenseReasonsType: builder.query({
      query: () => ({
        url: `/collections/GetDBSet?entityNameCode=${DBEntityNameCodes.SeriousOffenseReasonsType}`,
        method: "GET",
      }),
    }),
    getApproximateReportLocation: builder.query<{ reportId: number }>({
      query: ({ reportId }) => {
        return {
          url: `/reports/GetApproximateReportLocation`,
          method: "GET",
          params: { reportId: reportId.toString() },
        };
      },
      providesTags: ["reportLocationStep"],
    }),
    updateReportDetailsByController: builder.mutation({
      query: (data) => {
        const { body, role } = data;
        return {
          url: `/reports/UpdateReportDetailsByController?role=${role}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Report", id: arg.id },
        "ReportsList",
        "reportDetailsFirstStep",
        "reportSummary",
      ],
    }),
    addOrUpdateeReportLocationByController: builder.mutation({
      query: (body) => {
        return {
          url: "/reports/addOrUpdateeReportLocationByController",
          method: "POST",
          body: {
            ...body,
          },
        };
      },
      invalidatesTags: ["reportLocationStep"],
    }),
    getReportSummary: builder.query({
      query: (data) => {
        const { role, reportId } = data;
        return {
          url: `/reports/GetReportSummaryScreen`,
          method: "GET",
          params: { role: role.toString(), reportId: reportId.toString() },
        };
      },
      providesTags: ["reportSummary"],
    }),

    updateReportSummaryByController: builder.mutation({
      query: (data) => {
        const { body, role, isStatusUpdate } = data;
        return {
          url: `/reports/UpdateReportSummary?role=${role}&isStatusUpdate=${isStatusUpdate}`,
          method: "POST",
          body: {
            ...body,
          },
        };
      },
      invalidatesTags: [
        "reportSummary",
        "ReportsList",
        "CompletedReports",
        "ReversedDecisions",
      ],
    }),
    updatePoliceDecision: builder.mutation({
      query: (data) => {
        return {
          url: "/controlcenter/UpdatePoliceDecision",
          method: "POST",
          body: data,
          cache: "no-cache",
        };
      },
    }),
    sendToPolice: builder.mutation({
      query: () => {
        return {
          url: "/controlcenter/sendToPolice",
          method: "POST",
        };
      },
      invalidatesTags: ["ReportsList"],
    }),
    pullReportToSeniorController: builder.mutation({
      query: (reportID) => {
        return {
          url: "/backOffice/PullReportToSeniorController",
          method: "POST",
          params: { reportID },
        };
      },
      invalidatesTags: ["ReportsList"],
    }),
    pullReportToControlCenter: builder.mutation({
      query: (reportID) => {
        return {
          url: "/backOffice/PullReportToControlCenter",
          method: "POST",
          params: { reportID },
        };
      },
      invalidatesTags: ["ReportsList"],
    }),
    getReportLogs: builder.query({
      query: ({ reportID, role }) => ({
        url: "/collections/GetReportLogs",
        method: "GET",
        params: { reportID, role },
      }),
    }),
    getCarsSummary: builder.query({
      query: ({ page, filter }) => ({
        url: `/recapes/GetCarsSummary?page=${page}`,
        method: "POST",
        body: filter,
      }),
    }),
    getReportsByLicenseNumber: builder.query({
      query: ({ licenseNumber, filter, page }) => ({
        url: `/recapes/GetReportsByLicenseNumber?licenseNumber=${licenseNumber}&page=${page}`,
        method: "POST",
        body: filter,
      }),
    }),
    getControllersSummary: builder.query({
      query: ({ filter, page }) => ({
        url: `/recapes/GetContollersSummary?page=${page}`,
        method: "POST",
        body: filter,
      }),
    }),
    getReportsByController: builder.query({
      query: ({ controllerId, filter, page }) => ({
        url: `/recapes/GetReportsByController?controllerId=${controllerId}&page=${page}`,
        method: "POST",
        body: filter,
      }),
    }),
    getProductsSummary: builder.query({
      query: ({ filter, page }) => ({
        url: `/recapes/GetProductsSummary?page=${page}`,
        method: "POST",
        body: filter,
      }),
    }),
    getVolunteersSummary: builder.query({
      query: ({ filter, page }) => ({
        url: `/recapes/GetVolunteersSummary?page=${page}`,
        method: "POST",
        body: filter,
      }),
    }),
    getProcessStatus: builder.query({
      query: () => ({
        url: "/controlcenter/GetProcessStatus",
        method: "GET",
      }),
    }),
    getSuggestionList: builder.query({
      query: () => ({
        url: "backOffice/GetSuggestions",
        method: "GET",
      }),
    }),
    addOrUpdateSuggestion: builder.mutation({
      query: (payload) => ({
        url: "backOffice/SaveSuggestion",
        method: "POST",
        body: payload,
      }),
    }),
    LoadChangeStatusesExcel: builder.mutation({
      query: (data) => ({
        url: "controlcenter/LoadChangeStatusesExcel",
        method: "POST",
        body: data,
        cache: "no-cache",
      }),
      invalidatesTags: ["ReportsList"],
    }),
    LoadChangeDecisionsExcel: builder.mutation({
      query: (data) => ({
        url: "controlcenter/LoadChangeDecisionsExcel",
        method: "POST",
        body: data,
        cache: "no-cache",
      }),
      invalidatesTags: ["ReportsList"],
    }),
  }),
});

export const {
  useGetStatusesQuery,
  useGetReportRejectionReasonQuery,
  useGetReportsListDtoQuery,
  useGetTagsQuery,
  useGetHistoryForLicenseQuery,
  useGetReportsViolationTypesQuery,
  useGetCompletedQuery,
  useGetReversedDecisionsQuery,
  useGetNotificationsQuery,
  useGetReporterInformationQuery,
  useGetReportInformationFirstStepQuery,
  useGetSeriousOffenseReasonsTypeQuery,
  useGetApproximateReportLocationQuery,
  useUpdateReportDetailsByControllerMutation,
  useAddOrUpdateeReportLocationByControllerMutation,
  useUpdatePoliceDecisionMutation,
  useSendToPoliceMutation,
  usePullReportToSeniorControllerMutation,
  usePullReportToControlCenterMutation,
  useUpdateReportSummaryByControllerMutation,
  useGetReportSummaryQuery,
  useGetReportLogsQuery,
  useGetCarsSummaryQuery,
  useGetReportsByLicenseNumberQuery,
  useGetControllersSummaryQuery,
  useGetReportsByControllerQuery,
  useGetProductsSummaryQuery,
  useGetVolunteersSummaryQuery,
  useGetProcessStatusQuery,
  useLoadChangeStatusesExcelMutation,
  useLoadChangeDecisionsExcelMutation,
} = reportsApiSliceDev;
